export const requiredFields = [
  "defaultLayoutFriendlyName",
  "associatedType",
  "associatedDeviceTypes",
  "associatedVisitTypes",
];

export const openFields = ["selectedFieldOnViewport"];
